import { authHeader, isJson } from '../_helpers';
import { decode } from 'jsonwebtoken';


export const userService = {
    login,
    logout,
    registerUser,
    getAll,
    getUser
};


function getUser(history) {
    let myUserString = sessionStorage.getItem('user');
    let myUser;
    try {
        myUser = JSON.parse(myUserString);       
        const decodedToken = decode(myUser?.token || '');
        if (decodedToken == null || (decodedToken.exp < new Date().getTime() / 1000) ) {           
            console.log("EXPIRED");
            if (history) {
                history.push("/login");
            }           
        }
        myUser.employee = myUser.LOGIN_ROLE === 'U' ? myUser.NAME : myUser.ID;
    } catch (e) {
        myUser = { token: '' };
    }
    return myUser;
}

function registerUser(username, code2, invoice_no, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ card_id: username, user_pwd: password, code2, invoice_no })
    };


    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/users/register`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user) {
                // store user details and basic auth credentials in local storage
                // to keep user logged in between page refreshes
                // user.authdata = window.btoa(username + ':' + password);
                sessionStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        }).catch((error) => {
            console.error('Error:', error);
            sessionStorage.setItem('user', {});
            return ({ 'error': true, "message": (error ? error.toString(): "Auth Failed by Code2 and Invoice") });
        });

}
function login(login_id, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ login_id, user_pwd: password })
    };

    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/users/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user) {
                // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
                // user.authdata = window.btoa(username + ':' + password);
                sessionStorage.setItem('user', JSON.stringify(user));
                if (user.LOGIN_ROLE === 'C') {
                    sessionStorage.setItem('card', JSON.stringify(user));
                }
            }

            return user;
        })
        .catch((err) => {
            console.log(err);
            sessionStorage.setItem('user', {});
            return { "error": true, "message": err };
        });

}

function logout(history) {
    // remove user from local storage to log user out

    localStorage.removeItem('user');
    if (history) {
        history.push('/login')
    }
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_REST_URL}/users`, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = isJson(text) ? JSON.parse(text) : { message: response.statusText };
        if (response.ok) {
            console.log(data);
            return data;
        } else {
            console.log(`-------- ${text} --------`);
            //const error = (data && data.message) || response.statusText;
            return Promise.reject(data.message);
        }
    });
}


